import {enumType} from 'common/enumType';

const buildType = (
   id: string,
   name: string,
   notificationsId: string,
   notificationsText: string
) => ({
   id,
   name,
   notificationsId,
   notificationsText,
});

export const JobCompletionStatus = enumType({
   CANCELLED: buildType('CANCELLED', 'Cancelled', 'FAILURE', 'was cancelled'),
   CRITICAL: buildType('CRITICAL', 'Critical', 'CRITICAL FAILURE', 'failed'),
   ERROR: buildType('ERROR', 'Failure', 'FAILURE', 'failed'),
   FILE_NOT_FOUND: buildType('FILE_NOT_FOUND', 'File(s) Not Found', 'RETRY', ''),
   INCOMPLETE: buildType('INCOMPLETE', 'Incomplete', '', ''),
   MISSED: buildType('MISSED', 'Missed', '', ''),
   PREVIEW_LICENSE: buildType('PREVIEW_LICENSE', 'Preview License', '', ''),
   REQUIRED_FILE_NOT_FOUND: buildType(
      'REQUIRED_FILE_NOT_FOUND',
      'Required File(s) Not Found',
      '',
      ''
   ),
   SUCCESSFUL: buildType('SUCCESSFUL', 'Successful', 'SUCCESS', 'was successful'),
   TERMINATED: buildType('TERMINATED', 'Terminated', 'FAILURE', 'was terminated'),
   WARNING: buildType('WARNING', 'Warning', 'WARNING', 'was successful with a warning'),
});
